import React from 'react';
import BlackCheckMarkIcon from 'app/assets/svgIcons/BlackCheckMarkIcon';
import styles from './AudienceStrategicAlignmentField.module.scss';

interface MustWinDropdownPortalProps {
  groupedMustWinOptions: Record<string, string[]>;
  audienceStrategyMappings: Record<string, string[]>;
  onToggleMustWinOption: (audience: string, option: string) => void;
}

export const MustWinDropdownPortal: React.FC<MustWinDropdownPortalProps> = ({
  groupedMustWinOptions,
  audienceStrategyMappings,
  onToggleMustWinOption
}) => {
  return (
    <div
      className={`mustwin-dropdown-portal ${styles.mustWinDropdownMenu}`}
      onClick={e => e.stopPropagation()}
    >
      {Object.keys(groupedMustWinOptions).length === 0 ? (
        <div className={styles.emptyState}>No options available</div>
      ) : (
        Object.entries(groupedMustWinOptions).map(
          ([audience, options], categoryIndex) => (
            <div
              key={audience}
              className={
                categoryIndex === 0
                  ? styles.firstCategory
                  : styles.categoryGroup
              }
            >
              <div className={styles.categoryHeader}>{audience}</div>
              {options.map(option => {
                const isSelected =
                  audienceStrategyMappings[audience]?.includes(option) || false;
                return (
                  <div
                    key={`${audience}-${option}`}
                    className={`${styles.categoryOption} ${
                      isSelected ? styles.selected : ''
                    }`}
                    onClick={e => {
                      e.stopPropagation();
                      onToggleMustWinOption(audience, option);
                    }}
                  >
                    <span className={styles.optionText}>{option}</span>
                    <span className={styles.checkmarkContainer}>
                      {isSelected && (
                        <BlackCheckMarkIcon width={18} height={14} />
                      )}
                    </span>
                  </div>
                );
              })}
            </div>
          )
        )
      )}
    </div>
  );
};
